import { useI18n } from 'builder/hooks/useI18n'
import { TRANSLATION } from '../../../constants'
import { Service } from '../../../../types'
type ResumeTailoringStatus = 'initial' | 'progress' | 'completed'

type ResumeTailoringInfo = {
  badge: string
  header: string
  subHeader: string
  actionText: string
  modalTitle: string
}

type ResumeTailoringHookConfig = {
  isLoading: boolean
  text: ResumeTailoringInfo
  status: ResumeTailoringStatus
}

export const useResumeTailoringConfig = (service: Service): ResumeTailoringHookConfig => {
  const { i18n } = useI18n()

  const getStatus = (): ResumeTailoringStatus => {
    if (service.calculatedProgress.percentageProgress >= 100) return 'completed'
    return 'initial'
  }

  const getText = () => {
    const status = getStatus()
    const key = status === 'completed' ? 'completed' : `resume_tailoring.${status}`

    return i18n.t(`${TRANSLATION}.${key}`) as unknown as ResumeTailoringInfo
  }

  return {
    isLoading: false,
    text: getText(),
    status: getStatus(),
  }
}
